export default __webpack_public_path__ + "static/media/jakob_laemmle_01.d7d8264d.webp";